/* eslint-disable react/button-has-type */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';

const styles = {
  container: {
    padding: '20px',
    border: '1px solid #d0d9de',
    backgroundColor: 'white',
    borderRadius: '12px',
    marginBottom: '10px',
  },
  button: {
    all: 'unset',
    width: '100%',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textContainer: {
    textAlign: 'left',
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '6px',
  },
  description: {
    fontSize: '12px',
  },
  arrow: {
    display: 'flex',
    alignItems: 'center',
    color: '#2e5fca',
    fontSize: '16px',
    fontWeight: 600,
  },
  content: {
    padding: '12px 0',
  },
};

const AssessmentPanel = ({
  title,
  description,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const togglePanel = () => setIsOpen(prev => !prev);

  return (
    <div style={styles.container}>
      <button
        style={styles.button}
        onClick={togglePanel}
        aria-expanded={isOpen}
      >
        <div style={styles.textContainer}>
          <h2 style={styles.title}>{title}</h2>
          <p style={styles.description}>{description}</p>
        </div>
        <div style={styles.arrow}>
          <span>
            {isOpen ? (
              <FormattedMessage defaultMessage="Close Results" />
            ) : (
              <FormattedMessage defaultMessage="Show Results" />
            )}
          </span>
          {isOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </div>
      </button>

      {isOpen && <div style={styles.content}>{children}</div>}
    </div>
  );
};

AssessmentPanel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
};

export default AssessmentPanel;
